



























import { SdsButtonIcon } from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'BetBuilderSummaryHeaderMobile',
    props: {
        title: {
            type: String,
            required: true,
        },
        selectionsCount: {
            type: Number,
            required: true,
        },
    },
    emits: ['clear:selections'],
    components: {
        SdsButtonIcon,
    },
});
